import React from 'react';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { useResponsive } from '../../../hooks/useResponsive';
import { popupSlice } from '../../../services/reducers';
import MapModal from '../../../layouts/Modal/MapModal';
import tools from '../../../utils/tools';

interface AddressSectionProps {
  form: any;
  address: any;
  setAddress: (address: any) => void;
  updateNestedField: (parent: string, field: string, value: any) => void;
}

const AddressSection: React.FC<AddressSectionProps> = ({
                                                         form,
                                                         address,
                                                         setAddress,
                                                         updateNestedField
                                                       }) => {
  const dispatch = useDispatch();
  const { isMobile, getSelectStyles } = useResponsive();

  const handleAddressSelect = (selected: any) => {
    const selectedAddress = form.user?.addresses?.find(e => e.id === selected.value) || {
      phoneNumber: '',
      title: '',
      vahed: '',
      pelak: '',
      description: '',
      id: null
    };

    setAddress(selectedAddress);
  };

  const openMapModal = () => {
    dispatch(popupSlice.middle(<MapModal address={address} setAddress={setAddress} />));
  };

  return (
    <div className="infoSection">
      <h1 className="dashBoardTitle">آدرس</h1>
      <div className="orderInfoBox">
        <label className="sideBarTitle" htmlFor="addressSelect">آدرس های پیشین</label>
        <Select
          id="addressSelect"
          className="addressInput dirRtl"
          styles={getSelectStyles()}
          options={tools.selectFormatter(form.user?.addresses, 'id', 'description', 'آدرس جدید')}
          value={{
            value: form?.address?.id || '',
            label: form.user?.addresses?.find((e: any) => e.id === form?.address?.id)?.description || 'آدرس جدید'
          }}
          onChange={handleAddressSelect}
          placeholder="انتخاب آدرس"
          isSearchable={false}
          aria-label="آدرس های پیشین"
        />

        <label className="sideBarTitle" htmlFor="addressTitle">عنوان</label>
        <input
          id="addressTitle"
          className="editProductInput"
          type="text"
          value={form.address?.title || ''}
          onChange={(e) => updateNestedField('address', 'title', e.target.value)}
          placeholder="عنوان آدرس"
          aria-label="عنوان آدرس"
        />

        <label className="sideBarTitle" htmlFor="addressPhone">شماره تماس</label>
        <input
          id="addressPhone"
          className="editProductInput"
          type="tel"
          value={form.address?.phoneNumber || ''}
          onChange={(e) => {
            const value = e.target.value.replace(/[^0-9]/g, '');
            if (value.length <= 11) {
              updateNestedField('address', 'phoneNumber', value);
            }
          }}
          placeholder="09123456789"
          maxLength={11}
          aria-label="شماره تماس آدرس"
        />

        <label className="sideBarTitle" htmlFor="addressPelak">پلاک</label>
        <input
          id="addressPelak"
          className="editProductInput"
          type="text"
          value={form.address?.pelak || ''}
          onChange={(e) => updateNestedField('address', 'pelak', e.target.value)}
          placeholder="شماره پلاک"
          aria-label="پلاک"
        />

        <label className="sideBarTitle" htmlFor="addressVahed">واحد</label>
        <input
          id="addressVahed"
          className="editProductInput"
          type="text"
          value={form.address?.vahed || ''}
          onChange={(e) => updateNestedField('address', 'vahed', e.target.value)}
          placeholder="شماره واحد"
          aria-label="واحد"
        />

        <label className="sideBarTitle" htmlFor="addressDescription">جزئیات آدرس</label>
        <textarea
          id="addressDescription"
          className="editProductInput"
          value={form.address?.description || ''}
          onChange={(e) => updateNestedField('address', 'description', e.target.value)}
          placeholder="آدرس کامل"
          rows={isMobile ? 3 : 4}
          aria-label="جزئیات آدرس"
        />

        <button
          className="addProductButton"
          onClick={() => {openMapModal()}}
          aria-label="ویرایش آدرس"
        >
          ویرایش آدرس
        </button>
      </div>
    </div>
  );
};

export default AddressSection;
